import React from "react";

export default () => {
    return (
        <div>
            <i className="far fa-eye"></i>
        </div>
    )
}
